export const extractFiltersQuery = (filters) => { /* eslint-disable-line */
  return Object.keys(filters)
  .filter(filterName => filters[filterName])
  .map(filterName => `&${filterName}=${filters[filterName]}`)
  .join('');
};
